import React from 'react';
import {getDefStr} from "../utils/ReactUtils";

const MsgBox = (props, ...rest) => (
    <>
        <div
            className={`w-100 success-msg border-none text-${getDefStr(props.textAt, 'center')} 
            d-flex text-wrap flex-wrap justify-content-${getDefStr(props.textAt, 'center')} 
            align-items-${getDefStr(props.textAt, 'center')} 
            outline-none px-2x py-1 m-0 overflow-hiddenx scroller scroller-y-auto transition ${props.className}`}
            id={"success-msg"}
            style={{
                // color: props.msgColor,
                color: getDefStr(props.color, "black", ""),
                fontSize: getDefStr(props.fontSize, "", ""),
                height: getDefStr(props.height, "auto", ""),
                opacity: getDefStr(props.opacity, 1, ""),
                ...props.style
            }}
            {...rest}
        >
            {props.children}
        </div>
    </>
);

export default MsgBox;
